import React from 'react'
export default () => {
    return (
        <div></div>
    );
};

// import React from 'react'
// import {Link} from 'react-router';
// import TextField from 'material-ui/TextField';
// import RaisedButton from 'material-ui/RaisedButton';


// export default class Footer extends React.Component {

// 	render(){
// 		return (
// 			<div >
// 				<div className="build_footer hide_overflow">
// 					<div className="container">
// 						<div className="row">
// 							<div className="col-sm-12 ">

// 								<div class="">
// 									<h2>It’s time to partner up</h2>
// 									<p>
// 										Tipigo is on the forefront of a new investing dynamic, presenting a new trading approach that uses the fundamentals, yet is fundamentally different. <br/><br/> We welcome investors of all types to join us on the ride.
// 									</p>
// 									<br/>
// 									<Link to="contact_us" className="btn btn-success btn-raised contact_us_btn">CONTACT US</Link>
// 								</div>
// 							</div>
// 						</div>
// 			    	</div>
			    
// 			    </div>
// 			</div>
		   
// 		);
// 	}
   
// }


// WEBPACK FOOTER //
// ./src/js/components/Footer.js